import React, { useEffect, useState } from "react";
import { Card, Table, Button, Badge, Spinner } from "react-bootstrap";
import API from "../services/api";

const GuardDashboard = () => {
  const [vehicles, setVehicles] = useState([]);
  const [counts, setCounts] = useState({ total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      const res = await API.get("/guard/dashboard");
      setVehicles(res.data?.vehicles || []);
      setCounts(res.data?.counts || { total: 0 });
      setError("");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load gate dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h4 className="text-white mb-1">Live Gate Movements</h4>
          <div className="text-muted" style={{ fontSize: "12px" }}>
            Only approved vehicle requests are visible here.
          </div>
        </div>
        <Button variant="success" onClick={fetchDashboard}>
          Refresh
        </Button>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <Card className="shadow-sm">
            <Card.Body>
              <div className="text-muted" style={{ fontSize: "12px" }}>
                Total Approved
              </div>
              <div style={{ fontSize: "24px", fontWeight: 700 }}>
                {counts.total || vehicles.length}
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-3">
          <Card className="shadow-sm">
            <Card.Body>
              <div className="text-muted" style={{ fontSize: "12px" }}>
                Arrived
              </div>
              <div style={{ fontSize: "24px", fontWeight: 700 }}>{counts.arrived || 0}</div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-3">
          <Card className="shadow-sm">
            <Card.Body>
              <div className="text-muted" style={{ fontSize: "12px" }}>
                Verified
              </div>
              <div style={{ fontSize: "24px", fontWeight: 700 }}>{counts.verified || 0}</div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-3">
          <Card className="shadow-sm">
            <Card.Body>
              <div className="text-muted" style={{ fontSize: "12px" }}>
                Exited
              </div>
              <div style={{ fontSize: "24px", fontWeight: 700 }}>{counts.exited || 0}</div>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Card className="shadow-sm">
        <Card.Header className="fw-bold">Approved Vehicles</Card.Header>
        <Card.Body>
          {loading && (
            <div className="d-flex justify-content-center py-4">
              <Spinner animation="border" />
            </div>
          )}
          {error && <div className="text-danger">{error}</div>}
          {!loading && !error && vehicles.length === 0 && (
            <div className="text-muted">No approved vehicles right now.</div>
          )}
          {!loading && vehicles.length > 0 && (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Vehicle</th>
                  <th>Vendor</th>
                  <th>Material</th>
                  <th>Type</th>
                  <th>Qty</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {vehicles.map((vehicle) => (
                  <tr key={vehicle._id}>
                    <td>{vehicle.vehicleNumber}</td>
                    <td>{vehicle.vendorName}</td>
                    <td>{vehicle.materialName || "N/A"}</td>
                    <td>{vehicle.materialType}</td>
                    <td>
                      {vehicle.quantity || 0} {vehicle.unit || ""}
                    </td>
                    <td>
                      <Badge bg="secondary">{vehicle.gateStatus || "pending"}</Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default GuardDashboard;
